const TokenInfoNoKya = () => (
  <div className='py-5'>
    <span className='text-label1 text-main-muted text-center block font-bold'>
      No KYA available for this token
    </span>
  </div>
)

export default TokenInfoNoKya
